export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "org_invoice": {
            "invoice_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Factura"])},
            "amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto"])},
            "container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedor"])},
            "invoice_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de factura"])},
            "amount_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto pagado"])},
            "paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagada"])},
            "currency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moneda"])}
          }
        }
      }
    }
  })
}